import { Component } from '@angular/core';
import { StoreService } from '@appCore/services';

import { Observable } from 'rxjs';

@Component({
    selector: 'app-loading-animation',
    template: `<div class="spinner-container" *ngIf="loading$ | async">
        <mat-spinner></mat-spinner>
    </div>`
})
export class LoadingAnimationComponent {
    get loading$(): Observable<boolean> {
        return this.storeService.selectIsLoading();
    }

    constructor(private storeService: StoreService) {}
}
